const state = {
  data: {},
  hidden: false,
  id: null,
  owner_id: undefined,
  owner_type: undefined,
  template_checklist: false,
  title: '',
  user_id: undefined,
  workflow: false,
}

export const requiredFields = [
  { key: 'owner_id', validation: (value: unknown, entityState: { owner_type?: string }) => entityState.owner_type === 'System' || !!value },
  { key: 'owner_type' },
  { key: 'title' },
]

export default state
